export const API_URL = `https://vpn.shadownode.org/api/`;  //for prodection 
// export  const API_URL = `http://localhost:5000/api/`;  //for development

// export const WEBSITE_URL = "https://admin.anonsol.finance/" //for prodection 
export const WEBSITE_URL = "http://localhost:3000/"    //for development
const REACT_APP_GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY

export const mapOptions = {
    apiKey : REACT_APP_GOOGLE_MAPS_KEY
} 
// const REACT_APP_GOOGLE_MAPS_KEY = "AIzaSyCVoEvrK7c0YhrECe8F5zVenZDsS0QhpJY";
// export const REACT_APP_GOOGLE_MAPS_KEY = "AIzaSyBqGwelZ9kR4Q6eL9FdMa6v9Pt-P0osa6s"; 

export const BLOG_URL = `https://blog.shadownode.org/` // For Blogs 